/*
    Display shell for a list of trip on time records,
    split by media queries for different screen sizes

    - there's a lot of data here, so it's split into different
    modes, which can be switched between:

    Location
    Garage
    Route
    Run
    Lane
    User
    Delays

    Delay mode is a different data row display
    Route and Run mode need to use AutoSize + FixedSizeList to only render
        the records which are currently on screen at any time

    other modes have variable height, so can't do so
*/

import React, { useContext } from "react";
import Media from "react-media";

import MainContext from "../MainContext";
import DataContext from "../DataContext";

import VerticalLayout from "../Components/VerticalLayout";
import SubNav from "../Components/SubNav";
import MultiSelect from "../Components/MultiSelect";

import ReportTripOnTimeFilter from "../Filters/ReportTripOnTimeFilter";
import ReportTripOnTimeData from "../DataDisplay/ReportTripOnTimeData";
import ReportDelayData from "../DataDisplay/ReportDelayData";

import ReportExport from "../Components/Excel/ReportExport";

import { getTripOnTimeReport, getTripOnTimeReportPDF } from "../Requests/ReportRequests";

// height 45px (including 6px bottom margin) for Route and Run elements on laptop
// 76px for tablet
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

//
// wrapper container for making sure that we can respond immediately to
// when the DataContext indicates we need a data reload
//
const ReportTripOnTimePageContainer = (props) => {
    const context = useContext(DataContext);

    return (
        <ReportTripOnTimePage {...props}
            dataReload={context.dataReload}
            setReload={context.setReload}
        />
    )
};

export default ReportTripOnTimePageContainer;

class ReportTripOnTimePage extends React.Component {

    static contextType = MainContext;

    state = {
        filterValues: null,
        data: [],
        LocationData: [],
        GarageData: [],
        RouteData: [],
        RunData: [],
        LaneData: [],
        UserData: [],
        DelaysData: [],
        mode: "Location",
        message: "",
        exportList: [],
        exportSetup: false,
        grandTotal: null
    }

    //
    //
    applyFilter = (values, callback) => {
        this.context.toggleFilter();
        this.setState({
            filterValues: values,
            LocationData: [],
            GarageData: [],
            RouteData: [],
            RunData: [],
            LaneData: [],
            UserData: [],
            DelaysData: [],
            exportSetup: false,
            exportList: []
        }, () => {
            this.getData(callback);
        });
    }

    //
    // switch between the many different modes of this report
    //
    setMode = (mode) => {
        console.log("SET MODE", mode);
        this.setState({mode}, () => {
            if(this.state[mode+"Data"].length > 0){
                this.setState({data: this.state[mode+"Data"], message: ""});
            }
            else{
                this.getData();
            }
        });
    }

    //
    //
    getData = (callback) => {

        this.setState({data: []}, () => {
            const request = () => getTripOnTimeReport(this.state.filterValues, this.state.mode);
    
            const then = ({data}) => {
    
                console.log("TRIP ON TIME DATA RETURNED", data);
    
                let total = 0;
                let rest = null;
    
                if(this.state.mode === "Delays"){
                    rest = data;
                }
                else{
                    total = (data && data.length) ? data[0].Total : 0;
                    rest = data.slice(1);
                }

                console.log("TRIP DATA AFTERWARDS?", total, rest);
    
                const message = (data.length > 1) ? "" : "No Records Found for this Filter";
    
                this.setState({data: rest, grandTotal: total, message, [this.state.mode+"Data"]: rest}, () => {
                    if(callback && typeof callback === "function"){
                        callback();
                    }
                });
            };
    
            this.context.runProcessing(request, then, "getTripOnTimeReport");
        });
    }

    //
    //
    runPDF = () => {
        const request = () => getTripOnTimeReportPDF(this.state.filterValues, this.state.exportList/*.map(v => v.toLowerCase())*/);
        const then = (res => {
            ;
        });
        this.context.runProcessing(request, then, "getTripOnTimePDF");
    }

    //
    // necessary method for using AutoSizer + FixedSizeList
    //
    NextRow = ({ index, style }) => (
        <div key={index} style={style}>
            <ReportTripOnTimeData data={this.state.data[index]} mode={this.state.mode} />
        </div>
    )

    updateValue = (evt) => {
        console.log("update value", evt);
        this.setState({[evt.target.name]:evt.target.value});
    }

    //
    // sub-component for showing the mode switching and export options
    //
    ReportButtonsSubNav = () => {

        // option-selected
        const mode = this.state.mode;

        return (
            <SubNav>
                <div onClick={() => this.setMode("Location")} className={`option ${mode === "Location" ? "option-selected" : ""} horizontal-spaced`}>TOTAL</div>
                <div onClick={() => this.setMode("Garage")} className={`option ${mode === "Garage" ? "option-selected" : ""} horizontal-spaced`}>GARAGE</div>
                <div onClick={() => this.setMode("Route")} className={`option ${mode === "Route" ? "option-selected" : ""} horizontal-spaced`}>ROUTE</div>
                <div onClick={() => this.setMode("Run")} className={`option ${mode === "Run" ? "option-selected" : ""} horizontal-spaced`}>RUN</div>
                <div onClick={() => this.setMode("Lane")} className={`option ${mode === "Lane" ? "option-selected" : ""} horizontal-spaced`}>LANE</div>
                <div onClick={() => this.setMode("User")} className={`option ${mode === "User" ? "option-selected" : ""} horizontal-spaced`}>USER</div>
                <div onClick={() => this.setMode("Delays")} className={`option ${mode === "Delays" ? "option-selected" : ""} horizontal-spaced`}>DELAYS</div>
                <MultiSelect 
                    name="exportList"
                    selected={this.state.exportList}
                    options={[
                        "Location","Garage","Route","Run","Lane","User","Delays"
                    ]} 
                    onChange={this.updateValue}
                    dataColumns={2}
                    doNotShow= {true}
                    onOpen={() => this.setState({exportSetup: false})}
                    onDone={this.exportSetupComplete}
                    label="Export Setup"
                />
                {
                    this.state.exportList.length > 0 && this.state.exportSetup
                    ? <>
                        <ReportExport filename={`TripOnTimeReport_${new Date()}`} data={this.getExportData()} filter={this.state.filterValues} />
                        <div className="option  " onClick={this.runPDF}>PDF</div>
                    </>
                    : null
                }

            </SubNav>
        )
    }

    //
    //
    exportSetupComplete = () => {
        // OK, here is where we need to get all of the data that we don't already have...
        // based on the selections in the state.exportList

        // need to loop them all into a promise.all

        // ugh... now I only want to run this if the user clicks on the Excel export...
        // which really messes with the whole structure here
        // well, for the time being, it won't prevent things from running, it'll just take longer...
        // so I'll fix this one later

        const request = () => {
            return Promise.all(this.state.exportList.map((exp) => {
                if(this.state[exp+"Data"].length > 0){
                    console.log("ToT request ALREADY", exp);
                    // return what we've already got
                    return new Promise((resolve, reject) => {
                        resolve({data: this.state[exp+"Data"]});
                    });
                }
                else{
                    console.log("ToT request", exp);
                    return getTripOnTimeReport(this.state.filterValues, exp);
                }
            }));
        }

        const then = (values) => {

            console.log("TOT processing values", values);

            const obj = {};
            this.state.exportList.forEach((exp, i) => {
                obj[exp+"Data"] = values[i].data;
            });

            console.log("TOT processing output", obj);

            this.setState(obj, () => {
                this.setState({exportSetup: true});
            });
        };

        this.context.runProcessing(request, then, "getTripOnTimeReport");
    }

    //
    //
    getExportData = () => {
        const data = [];

        // put it together based on the exportList
        this.state.exportList.forEach((exp) => {
            data.push({
                name: exp,
                reportSubjectLabel: exp,
                records: this.state[exp+"Data"]
            });
        });

        return data;
    }

    //
    //
    componentDidUpdate() {
        if(this.props.dataReload){
            console.log("GET DATA!!!");
            this.props.setReload(false, () => {                
                this.getData();
            });
        }
    }

    render() {

        const hasDate = this.state.data.length ? !!this.state.data[0].SchedDate : false;

        const tabletRecordHeight = hasDate ? 97 : 76;
        const laptopRecordHeight = hasDate ? 66 : 45;

        return (
            <>
            {
                // need a slightly different display for delay mode
                this.state.mode === "Delays"
                ? <VerticalLayout firstHeight={10}>
                    {
                        // show the subnav
                        this.ReportButtonsSubNav()
                    }
                    <div className="content" style={{paddingTop: this.context.filterOpen ? "0px" : "8px"}}>
                        <>
                        {
                            // the filter
                            this.context.hasFilter
                            && this.context.filterOpen
                                ? <ReportTripOnTimeFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                                : null
                        }
                        {
                            // we're showing delay data here
                            this.state.data.map((row, index) => {
                                return <ReportDelayData key={index} data={row} mode={this.state.mode} />
                            })
                        }
                        {
                            this.state.message
                            ? <div className="message">
                                {this.state.message}
                            </div>
                            : null
                        }
                        </>
                    </div>
                </VerticalLayout>
                : <>
                <Media query="(max-width: 811px)">
                    <VerticalLayout firstHeight={6}>
                        {
                            // 
                            !this.context.filterOpen
                            ? this.ReportButtonsSubNav()
                            : <>
                                <SubNav />
                                {
                                this.state.mode === "Route" || this.state.mode === "Run"
                                ? <div className="content-nooverflow" style={{paddingTop: this.context.filterOpen ? "0px" : "8px"}}>
                                    <>
                                    {
                                        // the filter
                                        this.context.hasFilter
                                        && this.context.filterOpen
                                            ? <ReportTripOnTimeFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                                            : null
                                    }
                                    {
                                        // the data
                                        this.state.data.length > 0
                                        ? <AutoSizer>
                                        {
                                            ({height, width}) => (
                                                <FixedSizeList
                                                className="fixed-list"
                                                height={height}
                                                width={width}
                                                itemCount={this.state.data.length}
                                                itemSize={tabletRecordHeight}
                                                >
                                                {this.NextRow}
                                                </FixedSizeList>
                                            )
                                        }
                                        </AutoSizer>
                                        : null
                                    }
                                    {
                                        this.state.message
                                        ? <div className="message">
                                            {this.state.message}
                                        </div>
                                        : null
                                    }
                                    </>
                                </div>
                                : <div className="content" style={{paddingTop: this.context.filterOpen ? "0px" : "8px"}}>
                                    <>
                                    {
                                        this.context.hasFilter
                                        && this.context.filterOpen
                                            ? <ReportTripOnTimeFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                                            : null
                                    }
                                    {
                                        this.state.data.map((row, index) => {
                                            return this.NextRow({index, style:{}});
                                        })
                                    }
                                    {
                                        this.state.message
                                        ? <div className="message">
                                            {this.state.message}
                                        </div>
                                        : null
                                    }
                                    </>
                                </div> 
                                }
                            </>
                        }
                    </VerticalLayout>
                </Media>
                <Media query="(min-width: 812px)">
                    <VerticalLayout firstHeight={this.context.filterOpen ? 0 : 15}>
                        {
                        !this.context.filterOpen
                        ? <div>
                            {
                                this.ReportButtonsSubNav()
                            }
                            {
                                this.state.data.length > 0
                                ? <div className="data" style={{
                                    display: "grid",
                                    gridTemplateColumns: "2fr 2fr 2fr 2fr 2fr 2fr 1fr 2fr 2fr 2fr 2fr 2fr",
                                    justifyItems: "center",
                                    alignItems: "center",
                                    gridGap: "4px",
                                    margin: "8px 24px 0 8px",
                                    fontWeight: "bold",
                                    background: "var(--purple)",
                                    position: "relative"
                                }}>
                                    <div style={{
                                        position: "absolute",
                                        top: "110%",
                                        left: "0%",
                                        backgroundColor: "rgb(239 213 246)",
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between"
                                    }}>
                                        <div>Total Scheduled Trips: {this.state.grandTotal}</div>
                                    </div>
                                    <div>{this.state.mode.toUpperCase()}</div>
                                    <div>Total<br />Departed</div>
                                    <div>Sched<br />Late</div>
                                    <div>Sched<br />OT%</div>
                                    <div>Departed<br />Late</div>
                                    <div>Run<br />OT%</div>
                                    <div>PASS</div>
                                    <div>Boarding</div>
                                    <div>Arriving</div>
                                    <div>Getting<br />Off</div>
                                    <div>Left<br />Behind</div>
                                    <div>Departing</div>
                                </div>
                            : null
                            }
                            </div>
                        : null
                        }
                        {
                            this.state.mode === "Route" || this.state.mode === "Run"
                            ? <div className="content-nooverflow" style={{paddingTop: this.context.filterOpen ? "0px" : "8px"}}>
                                <>
                                {
                                    // the filter
                                    this.context.hasFilter
                                    && this.context.filterOpen
                                        ? <ReportTripOnTimeFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                                        : null
                                }
                                {
                                    // the data
                                    this.state.data.length > 0
                                    ? <AutoSizer>
                                    {
                                        ({height, width}) => (
                                            <FixedSizeList
                                            className="fixed-list"
                                            height={height}
                                            width={width}
                                            itemCount={this.state.data.length}
                                            itemSize={laptopRecordHeight}
                                            >
                                            {this.NextRow}
                                            </FixedSizeList>
                                        )
                                    }
                                    </AutoSizer>
                                    : null
                                }
                                {
                                    this.state.message
                                    ? <div className="message">
                                        {this.state.message}
                                    </div>
                                    : null
                                }
                                </>
                            </div>
                            : <div className="content" style={{paddingTop: this.context.filterOpen ? "0px" : "8px"}}>
                                <>
                                {
                                    this.context.hasFilter
                                    && this.context.filterOpen
                                        ? <ReportTripOnTimeFilter applyFilter={this.applyFilter} filterValues={this.state.filterValues} />
                                        : null
                                }
                                {
                                    this.state.data.map((row, index) => {
                                        return this.NextRow({index, style:{}});
                                    })
                                }
                                {
                                    this.state.message
                                    ? <div className="message">
                                        {this.state.message}
                                    </div>
                                    : null
                                }
                                </>
                            </div>
                        }
                    </VerticalLayout>
                </Media>
                </>
            }
            </>
        );
    }
}